/**
 * assets/backcountry-slider.js
 * Handles the Backcountry Slider, a drag-to-scroll slider component.
 * Includes mouse events for dragging and cursor updates.
 */
const BackcountrySlider = {
  /**
   * Initializes the slider.
   * @returns {void}
   */
  initSlider() {
    const slider = document.getElementById('slider');
    if (!slider) return;

    // Select arrows
    const previousButton = document.querySelector('.backcountry-lineup__slider-nav--prev');
    const nextButton = document.querySelector('.backcountry-lineup__slider-nav--next');

    // Drag variables
    let isDown = false;
    let startX;
    let scrollLeft;

    // Calculate scroll distance (card width + gap)
    const getScrollAmount = () => {
      // Find the first card to measure width
      const card = slider.querySelector('.backcountry-lineup__card');
      if (!card) return 300;
      
      // Get gap from CSS
      const style = window.getComputedStyle(slider);
      const gap = parseFloat(style.columnGap) || parseFloat(style.gap) || 12;
      
      return card.offsetWidth + gap;
    };

    // Update button states
    const updateButtonState = () => {
      if (!previousButton || !nextButton) return;
      
      // Check if we are at the start (allow 5px buffer)
      previousButton.disabled = slider.scrollLeft <= 5;
      
      // Check if we are at the end, (scrollLeft + clientWidth) is how much we've seen. 
      // Compare to scrollWidth (total length).
      const maxScroll = slider.scrollWidth - slider.clientWidth;
      nextButton.disabled = slider.scrollLeft >= maxScroll - 5;
    };

    if (previousButton && nextButton) {
      previousButton.addEventListener('click', () => {
        slider.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
      });

      nextButton.addEventListener('click', () => {
        slider.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
      });
    }

    const updateLayout = () => {
      // Check if content is wider than container
      const isScrollable = slider.scrollWidth > slider.clientWidth;

      if (isScrollable) {
        // Slider is larger than viewport (scroll needed)
        slider.style.cursor = 'grab';
        slider.classList.add('is-scrollable'); 
        // Show buttons if desktop
        if (previousButton) previousButton.style.display = window.matchMedia('(min-width: 700px)').matches ? 'flex' : 'none';
        if (nextButton) nextButton.style.display = window.matchMedia('(min-width: 700px)').matches ? 'flex' : 'none';
      } else {
        // Slider fits on screen (no scroll needed)
        slider.style.cursor = 'default';
        slider.classList.remove('is-scrollable'); 
        // Hide buttons if content fits
        if (previousButton) previousButton.style.display = 'none';
        if (nextButton) nextButton.style.display = 'none';
      }
      updateButtonState();
      return isScrollable;
    };

    // Run immediately and on resize
    updateLayout();
    updateButtonState();
    
    // Update state on scroll (to disable buttons at ends)
    slider.addEventListener('scroll', updateButtonState);
    window.addEventListener('resize', updateLayout);
    
    slider.addEventListener('mousedown', (e) => {
      if (!updateLayout()) return; 
      isDown = true;
      slider.classList.add('active');
      slider.style.cursor = 'grabbing';
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
    });

    const stopDragging = () => {
      isDown = false;
      slider.classList.remove('active');
      updateLayout();
    };

    slider.addEventListener('mouseleave', stopDragging);
    slider.addEventListener('mouseup', stopDragging);

    slider.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - slider.offsetLeft;
      const walk = (x - startX) * 2;
      slider.scrollLeft = scrollLeft - walk;
    });
  },
};

// Init on load
document.addEventListener('DOMContentLoaded', () => BackcountrySlider.initSlider());

// Init on 'Theme Editor' change (a Shopify specific event)
document.addEventListener('shopify:section:load', () => BackcountrySlider.initSlider());
